export default __webpack_public_path__ + "876f07267629823452ce8e84d54da5ed.png";